<div class="grid stock-address-step-layout" [formGroup]="formGroup">
  <div class="col-8">
    <div class="stock-address-map">
      <osp-location-search-field class="stock-address-map-search" (onLocationChanges)="locationChanges.emit($event)" />
      @if (isMapLoaded) {
        <google-map
          ospMapDefaultOptions
          [center]="mapCenter"
          [zoom]="14"
          [height]="'100%'"
          [width]="'100%'"
          (mapClick)="mapClick.emit($event)"
        >
          @if (mapMarkerPosition; as markerPosition) {
            <map-marker [position]="markerPosition" />
          }
        </google-map>
      }
    </div>
  </div>
  <div class="col-4 grid stock-address-inputs">
    <osp-form-field class="col-12">
      <osp-label>{{ 'general.address.street' | translate }}</osp-label>
      <osp-input-text formControlName="street" [placeholder]="'general.address.street' | translate" />
      <osp-error />
    </osp-form-field>
    <osp-form-field class="col-12">
      <osp-label>{{ 'general.address.number' | translate }}</osp-label>
      <osp-input-text formControlName="streetNumber" [placeholder]="'general.address.number' | translate" />
      <osp-error />
    </osp-form-field>
    <osp-form-field class="col-12">
      <osp-label>{{ 'general.address.postCode' | translate }}</osp-label>
      <osp-input-text formControlName="postalCode" [placeholder]="'general.address.postCode' | translate" />
      <osp-error />
    </osp-form-field>
    <osp-form-field class="col-12">
      <osp-label>{{ 'general.address.city' | translate }}</osp-label>
      <osp-input-text formControlName="city" [placeholder]="'general.address.city' | translate" />
      <osp-error />
    </osp-form-field>
    @if (showAutomaticGeofence) {
      <div class="col-12">
        <osp-checkbox
          formControlName="createGeofence"
          [label]="'modules.disposition.automatedTransfers.autoGeo' | translate"
        />
      </div>
    }
    <div class="col-12">
      <osp-error
        [errors]="formGroup.dirty ? formGroup.errors : null"
        [messages]="{ notResolved: 'modules.contact.contactAddEdit.addressCannotBeResolved' | translate }"
      />
    </div>
  </div>
</div>
